export default "__VITE_ASSET__BbInDzU0__"